<template>
  <v-toolbar
    :fixed="fixedToolbar"
    v-if="toolbar"
    :class="navToolbarScheme"
    :clipped-left="toolbarClippedLeft"
        class="orange darken-1"

    app
  >
    <v-toolbar-side-icon
      class="hidden-lg-and-up"
      @click.stop="$store.dispatch('toggleDrawer', ! navDrawer)"></v-toolbar-side-icon>
    <v-toolbar-title v-text="title" class="ml-0 hidden-lg-and-up"></v-toolbar-title>
   
    <img src="/static/SecurytyNewLogo4.png" height="60" :to="{name: 'HomePage2'}"  />
    
    <!-- <v-btn icon :to="{name: 'BlankPage'}" flat>
      <v-icon></v-icon>
    </v-btn>
    <v-btn icon :to="{name: 'BlankPage'}" flat>
      <v-icon></v-icon>
    </v-btn> -->
    
    <!-- <v-spacer></v-spacer> -->
    <p class="font-weight-black mTopLeft10">{{this.$store.getters.userEmail }}</p>
    <v-spacer></v-spacer>
    <v-menu class="font-weight-black mTopLeft10">
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'HomePage2'}" flat  class="white--text bold" >
      INICIO
      </v-btn>      
    </v-avatar>
    </v-menu>

    <v-menu >
      <v-avatar slot="activator" size="200">
      <v-btn icon :to="{name: 'FeaturesPage'}" flat class="white--text bold" >
      CARACTERISTICAS
      </v-btn>      
    </v-avatar>
    </v-menu>
  <!--  <v-menu >
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'SignaturePage'}" flat>
      PRODUCTS
      </v-btn>  
    </v-avatar>
      <v-list >
        <v-list-tile avatar>
          <v-list-tile-avatar>
        
          </v-list-tile-avatar>

          <v-list-tile-content>    
        <v-list-tile @click.native="showSignature()" >
          <v-list-tile-avatar>
            <v-icon>signature</v-icon>
            
          </v-list-tile-avatar>
          <v-list-tile-title>Electronic Signature</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click.native="showIdentification()" >
          <v-list-tile-avatar>
            <v-icon>camera</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Identity Verification</v-list-tile-title>
        </v-list-tile>  
    </v-menu>
-->
      <!-- <v-menu>
        <v-avatar slot="activator" size="80">
          <v-btn icon flat :class="{ 'v-btn--active': isProductsActive , '': !isProductsActive }">PRODUCTS</v-btn>
        </v-avatar>
        <v-list>
          <v-list-tile @click.native="showSignature()">
            <v-list-tile-avatar>
              <v-icon>person</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>Electronic Signature</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click.native="showNotification()">
            <v-list-tile-avatar>
              <v-icon>settings_applications</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>Certified Notification</v-list-tile-title>
          </v-list-tile>          
          <v-list-tile @click.native="showIdentification()">
            <v-list-tile-avatar>
              <v-icon>settings_applications</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>Identity Verification</v-list-tile-title>
          </v-list-tile>
        </v-list> 
      </v-menu> -->

    <v-menu >
      <v-avatar slot="activator" size="80">
        <v-btn icon :to="{name: 'ProductsPage'}" flat class="white--text bold" >
        PRODUCTOS
        </v-btn>      
      </v-avatar>
    </v-menu>

    <spacer></spacer>

    <v-menu >
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'ApiPageEs'}" flat class="white--text bold" >
      API
      </v-btn>      
    </v-avatar>
    </v-menu>
    <spacer></spacer>

    <v-menu >
      <v-avatar slot="activator" size="100">
      <v-btn icon :to="{name: 'PricingPage'}" flat class="white--text bold" >
      PRECIOS
      </v-btn>      
    </v-avatar>
    </v-menu>


    <v-menu v-if="!isLoggedIn">
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'LoginPage'}" flat class="white--text bold" >
      ACCESO
      </v-btn>      
    </v-avatar>
    </v-menu>

    <v-menu  v-if="!isLoggedIn" >
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'RegisterPage'}" flat class="white--text bold" >
      REGISTRO
      </v-btn>      
    </v-avatar>
    </v-menu>

   <v-menu v-if="isLoggedIn" >
      <v-avatar slot="activator" size="80">
        <v-btn icon :to="{name: 'ProfilePage'}" flat class="white--text bold" >
          MI CUENTA
        </v-btn> 
      </v-avatar>
      <!-- <v-list >
        <v-list-tile avatar>
          <v-list-tile-avatar>
        
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title v-text="authUser.userEmail"></v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click.native="editProfile()" >
          <v-list-tile-avatar>
            <v-icon>person</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Edit Profile</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="() => {}">
          <v-list-tile-avatar>
            <v-icon>settings_applications</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>My Orders</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="() => {}">
          <v-list-tile-avatar>
            <v-icon>mail</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>My Credits</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="signOut()">
          <v-list-tile-avatar>
            <v-icon>power_settings_new</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Sign Out</v-list-tile-title>
        </v-list-tile>
        
      </v-list> -->
    </v-menu>

    <v-menu v-if="isLoggedIn" >
      <v-avatar slot="activator" size="80">
      <v-btn icon @click="signOut()" flat class="white--text bold" >
      SALIR 
      </v-btn>      
    </v-avatar>
    </v-menu>

  </v-toolbar>
</template>
<script>
//import { authUser } from "@/data/dummyData";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      title: "",
      isProductsActive: false
    };
  },
  computed: {
    ...mapGetters({
      navDrawer: "navDrawer",
      toolbarClippedLeft: "toolbarClippedLeft",
      fixedToolbar: "fixedToolbar",
      toolbar: "toolbarVisibility",
      navToolbarScheme: "navToolbarScheme",
      navMiniVarient: "navMiniVarient"
    }),
    authUser() {
      return this.$store.getters.userData;
    },
    isLoggedIn() {
     // this.authUser = this.$store.getters.userData;
      return this.$store.getters.userLoggedIn;
    }
  },
  mounted() {
    this.authUser = this.$store.getters.userData;
    //   this.isLoggedIn = this.$store.getters.userLoggedIn
  },
  methods: {
    toggleMiniVariantMode() {
      this.$store.dispatch("toggleMiniVariantMode");
      this.$store.dispatch("toggleMiniVarient");
    },
    showSignature() {
      this.isProductsActive = true;
      this.$router.push({ name: "SignaturePage" });
    },
    showNotification() {
      this.isProductsActive = true;
      this.$router.push({ name: "NotificationPage" });
    },
    showIdentification() {
      this.isProductsActive = true;
      this.$router.push({ name: "IdentificationPage" });
    },
    editProfile() {
      this.isProductsActive = false;
      this.$router.push({ name: "ProfilePage" });
    },
    signOut() {
      this.isProductsActive = false;
      this.$store.commit("setUserLoggedIn", false);
      this.$store.commit("setUserEmail", "");
      this.$store.commit("setUserData", null);
      this.$router.push({ name: "HomePage" });
    }
    // home() {
    //   this.isProductsActive = false;
    // },
    // features() {
    //   this.isProductsActive = false;
    // },
    // api() {
    //   this.isProductsActive = false;
    // },
    // pricing() {
    //   this.isProductsActive = false;
    // },
    // login() {
    //   this.isProductsActive = false;
    // },
    // signUp() {
    //   this.isProductsActive = false;
    // },
    // myProfile() {
    //   this.isProductsActive = false;
    // }
  }
};
</script>

<style scoped>
.mTopLeft10 {
  margin: 0 0 0 10px;
}
</style>
